import { createPluralHelperForI18nKey, translate } from '../i18n';

import { getNewsSignalEventTags } from './newsSignal';
import { getTechnologiesListText, getTechnologySignalEventText } from './technologySignal';
import {
  getTrafficSignalEventConfig,
  getTrafficSignalEventTags,
  isTrafficChangesModel,
  isTrafficMarketModel,
} from './trafficSignal';

export const DAYS_IN_WEEK = 7;
export const DAYS_IN_MONTH = 30;
export const DAYS_IN_YEAR = 365;

export const SI_TIMEFRAME_PREFIX = 'company.signals.item.timeframe';

export const PERIOD_TO_NAME_MAP: Record<string, string> = {
  mom: 'month',
  qoq: 'quarter',
  yoy: 'year',
};

const makeSignalService = () => {
  const getTimeFrameTranslation = (timeframe: Readonly<{ amount: number; id: string }>): string => {
    const { amount, id } = timeframe;
    const getI18nSingularKey = createPluralHelperForI18nKey(`${SI_TIMEFRAME_PREFIX}.${id}`);

    if (amount === 1) {
      return `1 ${translate(getI18nSingularKey(1))?.toLowerCase()}`;
    }

    return `${amount} ${translate(`${SI_TIMEFRAME_PREFIX}.${id}`)}`;
  };

  const getSignalEventPeriod = (amount: number): string => {
    if (amount < DAYS_IN_WEEK) {
      return `${getTimeFrameTranslation({ amount, id: 'day' })}`;
    }
    if (amount >= DAYS_IN_WEEK && amount < DAYS_IN_MONTH) {
      return `${getTimeFrameTranslation({
        amount: Math.floor(amount / DAYS_IN_WEEK),
        id: 'week',
      })}`;
    }
    if (amount >= DAYS_IN_MONTH && amount < DAYS_IN_YEAR) {
      return `${getTimeFrameTranslation({
        amount: Math.floor(amount / DAYS_IN_MONTH),
        id: 'month',
      })}`;
    }
    return `${getTimeFrameTranslation({
      amount: Math.floor(amount / DAYS_IN_YEAR),
      id: 'year',
    })}`;
  };

  const getSignalEventDate = (amount: number): string => {
    if (amount === 0) {
      return translate(`${SI_TIMEFRAME_PREFIX}.today`);
    }
    return `${getSignalEventPeriod(amount)} ${translate(`${SI_TIMEFRAME_PREFIX}.ago`)}`;
  };

  return {
    getSignalEventDate,
    getSignalEventPeriod,
    getTrafficSignalEventConfig,
    getTrafficSignalEventTags,
    isTrafficMarketModel,
    isTrafficChangesModel,
    getTechnologySignalEventText,
    getTechnologiesListText,
    getNewsSignalEventTags,
  };
};

export const signalService = makeSignalService();
